export type SelectAmountForm = {
    [SelectAmountTypeFormFields.Quantity]: number;
};

export enum SelectAmountTypeFormFields {
    Quantity = 'quantity',
}
